import { Injectable } from '@angular/core';
import { AbstractHttpService } from './abstract-http-service';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AdvancedSettingsService extends AbstractHttpService {
  defaultOptions = {
    headers: this.contentTypeJsonHeaders,
    withCredentials: true
  };

  resetMappingHeaders = {
    headers: this.contentTypeFormUrlEncodedHeaders,
    withCredentials: true
  };

  constructor(private httpClient: HttpClient) {
    super();
  }

  /**
   * Gets Advanced settings for the account
   */
  public getAdvancedSettings(accountId: number): Observable<any> {
    return this.httpClient
      .get(
        `//${environment.autoDomain}:${environment.autoPort}/api/advanced/${accountId}`,
        this.defaultOptions
      )
      .pipe(catchError(this.handleError));
  }

  /**
   * Updates Advanced Settings
   * PUT /api/advanced-settings
   * Payload should match AdvancedSettingsRequest shape expected by backend
   */
  public updateAdvancedSettings(settings: any): Observable<any> {
    return this.httpClient.put(
      `//${environment.autoDomain}:${environment.autoPort}/api/advanced/${settings.accountId}`,
      settings,
      this.defaultOptions
    ).pipe(
      catchError(this.handleError)
    );
  }

  /**
      * Triggers a synchronous refresh of Offer Sets cache for the account
      * POST /api/advanced/{accountId}/refresh-cache
      */
  public refreshCache(accountId: number): Observable<void> {
    return this.httpClient.post<void>(
      `//${environment.autoDomain}:${environment.autoPort}/api/advanced/${accountId}/refresh-cache`,
      {},
      this.defaultOptions
    ).pipe(
      catchError(this.handleError)
    );
  }
}
